import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection,  getDocs, query, where, orderBy, limit, startAfter} from "firebase/firestore";
import { db } from "../firebase.config";
import { toast } from "react-toastify";
import Spinner from '../components/Spinner';
import ListingItem from '../components/ListingItm';

function Category() {

    const [ listings, setListings] = useState(null);
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [lastFetchedListing, setLastFetchedListing] = useState(null);

    useEffect(()=>{
        const fetchListings = async () =>{
            try {
                const listingsRef = collection(db, 'listings');
                // console.log(params.categoryName);
                const querylistings = query(listingsRef, where('type', '==', params.categoryName), orderBy('timestamp', 'desc',limit(10)));
                
                
                const qurySnap = await getDocs(querylistings);
                
                const lastVisible = qurySnap.docs[qurySnap.docs.length-1];

                setLastFetchedListing(lastVisible);
                
                const listings = [];

                qurySnap.forEach((doc)=>{
                    return listings.push({id: doc.id, data:doc.data()})
                });
                setListings(listings);
                setLoading(false);
            } catch (error) {
                toast.error('could not fetch listings')
            }
        }
        fetchListings()
    },[params.categoryName])

    // pagination/load more
    const onFetchMoreListings = async () =>{
        try {
            const listingsRef = collection(db, 'listings');
            // console.log(params.categoryName);
            const querylistings = query(listingsRef, where('type', '==', params.categoryName), orderBy('timestamp', 'desc',startAfter(lastFetchedListing),limit(10)));
            
            
            const qurySnap = await getDocs(querylistings);
            
            const lastVisible = qurySnap.docs[qurySnap.docs.length-1];

            setLastFetchedListing(lastVisible);
            
            const listings = [];

            qurySnap.forEach((doc)=>{
                return listings.push({id: doc.id, data:doc.data()})
            });
            setListings((prevState)=> [...prevState,...listings]);
            setLoading(false);
        } catch (error) {
            toast.error('could not fetch listings')
        }
    }

    return <div className="category">
        <header>
        <p className="pageHeader">{params.categoryName === 'rent'? 'Places for rent' : 'plsces for sale'}</p>
        </header>
        {loading ? <Spinner/> : listings && listings.length > 0 ? 
        <>
        <main>
            <ul className="categoryListings">
                {
                    listings.map((listing)=>(
                        <ListingItem listing={listing.data} id={listing.id} key={listing.id} />
                    ))
                }
            </ul>
        </main>
        <br />
        <br />
        {lastFetchedListing && (
            <p className="loadMore" onClick={onFetchMoreListings}>Load More</p>
        )}
        </>
        : <p>No listing for {params.categoryName}</p>}
        </div>;
}

export default Category;